export default __webpack_public_path__ + "static/media/i4.09239b4e.jpg";